export class Categoria {
  id: number;
  categoria: string;
  codigoTce: string;
  ativo: boolean;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/categorias/shared/categoria.model.ts
 **/